import { actionHelpers } from '../core';

export const getPreferences = actionHelpers.createAction('GET_PREFERENCES');
export const getPreferencesUser = actionHelpers.createAction('GET_PREFERENCES_USER');
export const getPreferencesDataset = actionHelpers.createAction('GET_PREFERENCES_DATASET');
export const getPreferencesSuccess = actionHelpers.createAction('GET_PREFERENCES_SUCCESS');
export const getPreferencesFailure = actionHelpers.createAction('GET_PREFERENCES_FAILURE');

export const setPreference = actionHelpers.createAction('SET_PREFERENCE');
export const setPreferenceSuccess = actionHelpers.createAction('SET_PREFERENCE_SUCCESS');
export const setPreferenceFailure = actionHelpers.createAction('SET_PREFERENCE_FAILURE');

export const deletePreference = actionHelpers.createAction('DELETE_PREFERENCE');
export const deletePreferenceSuccess = actionHelpers.createAction('DELETE_PREFERENCE_SUCCESS');
export const deletePreferenceFailure = actionHelpers.createAction('DELETE_PREFERENCE_FAILURE');

export const initAccountPreferences = actionHelpers.createAction('INIT_ACCOUNT_PREFERENCES');
export const resetAllPreferences = actionHelpers.createAction('RESET_ALL_PREFERENCES');
